import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import API_ROUTES from "../../constants/apis";
import { setAuthTokens } from "../../services/utils";

import logpic2 from "../../assets/sitting.jpg";

const Login = () => {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [notVerified, setNotVerified] = useState("");
  const [phoneMessage, setPhoneMessage] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");

  const navigate = useNavigate();

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await axios.post(API_ROUTES.SIGN_IN, {
        phone: phone,
        password: password,
      });

      console.log(response);
      console.log(response.data);

      const accessToken = response.data.access;
      const refreshToken = response.data.refresh;

      console.log(accessToken);
      console.log(refreshToken);

      setAuthTokens(accessToken, refreshToken);

      // setAccessToken(accessToken);

      navigate("/");
    } catch (error) {
      if (error.response) {
        setNotVerified(error.response.data.non_field_errors);
        if (error.response.data.phone && error.response.data.password) {
          setPhoneMessage("PhoneNumber Required");
          setPasswordMessage("Password Required");
        } else if (error.response.data.phone) {
          setPhoneMessage("PhoneNumber Required");
        } else if (error.response.data.password) {
          setPasswordMessage("Password Required");
        }
      } else {
        console.error("Error2:", error.message);
      }
    }
  };

  return (
    <div className="h-screen bg-slate-300 text-blue-950">
      <div className="h-5/6 flex justify-center items-center">
        <div className="h-50vh flex shadow-2xl rounded-lg bg-slate-200">
          <div
            className="bg-no-repeat bg-center bg-cover rounded-l-lg hidden md:block"
            style={{
              backgroundImage: `url(${logpic2})`,
            }}
          >
            <div>
              <h3 className=" text-center text-white text-2xl font-bold   p-2 ">
                Welcome to <br /> <span className="text-4xl">Student Keja</span>
              </h3>
            </div>
          </div>

          <div className="p-5 rounded-r-lg h-full flex flex-col items-center justify-center">
            <h2 className="text-center text-3xl">StudentKeja</h2>
            <h3 className="text-center text-xl">LOGIN</h3>
            <form
              onSubmit={handleSubmit}
              className="max-w-sm mx-auto bg-white/5 px-5 py-20"
            >
              <div className="mb-4">
                <PhoneInput
                  defaultCountry="KE"
                  id="phone"
                  placeholder="Phone Number eg: 791665710"
                  value={phone}
                  onChange={setPhone}
                  className="w-full bg-white/5 border-b border-blue-950 rounded-md py-2 px-4 focus:outline-none bg-slate-200"
                />
              </div>
              {phoneMessage && (
                <p className="text-center text-red-600 mt-2">{phoneMessage}</p>
              )}
              <div className="mb-4">
                <input
                  type="password"
                  id="password"
                  value={password}
                  placeholder="Password"
                  onChange={handlePasswordChange}
                  className="w-full border-b border-blue-950 rounded-md py-2 px-4 focus:outline-none bg-slate-200"
                />
              </div>
              {passwordMessage && (
                <p className="text-center text-red-600 mt-2">
                  {passwordMessage}
                </p>
              )}
              <button
                type="submit"
                className="w-full bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-md"
              >
                Login
              </button>
              {notVerified && (
                <p className="text-center text-red-600 mt-2">{notVerified}</p>
              )}
            </form>

            <div>
              <p>Forgot password?</p>
              <p>
                {" "}
                Don't have an account?
                <Link to="/register" className="text-red-500 p-2">
                  Register here
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      <p className="text-blue-950 text-center">
        © 2023 StudentKeja.com. All Rights Reserved | Developed by Rades
      </p>
    </div>
  );
};

export default Login;
